<template>
  <LayoutContainer>
    <UtilityHeadline
      v-if="data.headlineH2"
      :class="`dbc-text-color-${data.headlineH2Color}`"
      :text="data.headlineH2"
      :level="2"
      :aos="{ fadeDirection: 'fade-right', delay: 300 }"
    />
    <LayoutBlock
      :aos="{
        fadeDirection: 'fade-right',
        delay: 300,
        offset: 200,
      }"
    >
      <UtilityVideo
        v-if="data.video"
        :id="data.video.id"
        :title="data.video.title"
        :consent-layer="data.video.consentLayer"
      />
    </LayoutBlock>
    <UtilityText
      v-if="data.text"
      :class="`dbc-text-color-${data.textColor} max-w-[75%] max-tablet:max-w-full`"
      :text="data.text"
      :aos="{ fadeDirection: 'fade-right', delay: 500 }"
    />
  </LayoutContainer>
</template>
<script setup lang="ts">
const props = defineProps<{
  content: ContentVideo
}>()
const data = normalizeContentVideo(props.content)
</script>
